/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MdsMigrationResource } from '../models/MdsMigrationResource'

import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'

export class OrganizationsMdsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public listMdsMigrations({
        organization
    }: {
        /**
         * Organization ID
         */
        organization: number
    }): CancelablePromise<{
        data: Array<MdsMigrationResource>
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/organizations/{organization}/mds-migration',
            path: {
                organization: organization
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Migrate the organization to MDS.
     * Has optional sync query parameter to run the migration synchronously.
     * Sync should only be used for debugging using small organizations.
     * @returns any Accepted
     * @throws ApiError
     */
    public startMdsMigration({
        organization
    }: {
        /**
         * Organization ID
         */
        organization: number
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/organizations/{organization}/mds-migration',
            path: {
                organization: organization
            },
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Organization not found.`,
                409: `Migration already in progress.`
            }
        })
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getMdsMigration({
        organization,
        mdsMigration
    }: {
        /**
         * Organization ID
         */
        organization: number
        /**
         * MDS Migration ID
         */
        mdsMigration: number
    }): CancelablePromise<{
        data: MdsMigrationResource
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/organizations/{organization}/mds-migration/{mdsMigration}',
            path: {
                organization: organization,
                mdsMigration: mdsMigration
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public cancelMdsMigration({
        organization,
        mdsMigration
    }: {
        /**
         * Organization ID
         */
        organization: number
        /**
         * MDS Migration ID
         */
        mdsMigration: number
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/organizations/{organization}/mds-migration/{mdsMigration}',
            path: {
                organization: organization,
                mdsMigration: mdsMigration
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * @returns any Accepted
     * @throws ApiError
     */
    public restartMdsMigration({
        organization,
        mdsMigration
    }: {
        /**
         * Organization ID
         */
        organization: number
        /**
         * MDS Migration ID
         */
        mdsMigration: number
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/organizations/{organization}/mds-migration/{mdsMigration}/restart',
            path: {
                organization: organization,
                mdsMigration: mdsMigration
            },
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Organization or MDS Migration not found.`,
                409: `Migration has not started yet.`
            }
        })
    }
}
